import React, { PureComponent } from "react";
import { connect } from "react-redux";
import moment from "moment";

import { CYCLE_ITEMS } from "Config";
import { setCycleCombination } from "Actions";
import {
  initTimeSheetTree,
  setCurrentNavPage,
  setSubMenuDirection,
  setSubMenuDirectionToggle,
  setFilterClientGroup,
  setFilterClient,
  setFilterPeriods,
  setFilterCollaborators,
  setFilterTaskCategory
} from "Actions";
import TimeSheetTree from "./TimeSheetTree";
import { renderPeriodsByRangeDateAndPeriodUnit } from "Utils";
import { fetchTimeSheet, fetchNonCategorizedTaskTypeCount } from "Thunks";
import { HORIZONTAL, VERTICAL } from "Config";

class CollaboratorTimeSheetPage extends PureComponent {
  constructor(props) {
    super(props);
    let { id, name } = this.props.match.params;

    this.state = { id, name };
  }

  componentDidMount() {
    const { dispatch, subMenuDirection } = this.props;

    dispatch(setCurrentNavPage("TIME_SHEET_PAGE"));

    if (subMenuDirection === VERTICAL) {
      dispatch(setSubMenuDirection(HORIZONTAL));
    }
    dispatch(setSubMenuDirectionToggle(false));

    let combination = CYCLE_ITEMS.map(k => ({
      id: k,
      visible: true
    }));

    dispatch(initTimeSheetTree());
    dispatch(setCycleCombination(combination));
    this.props.dispatch(
      setFilterPeriods(
        renderPeriodsByRangeDateAndPeriodUnit(
          moment().startOf("year"),
          moment(),
          "year"
        )
      )
    );
    dispatch(
      setFilterCollaborators([
        { value: this.state.id, label: this.state.name, color: "#000000" }
      ])
    );
    dispatch(fetchTimeSheet());
    dispatch(fetchNonCategorizedTaskTypeCount());
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(setSubMenuDirectionToggle(true));
    dispatch(setFilterCollaborators([]));
    dispatch(setFilterClient([]));
    dispatch(setFilterClientGroup([]));
    dispatch(setFilterTaskCategory([]));
  }

  render() {
    return (
      <div className={`page-content`}>
        <TimeSheetTree
          collaborator={this.state.collaborator}
          hideCollaboratorFilter
        />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  organization: state.timeSheet.organization,
  subMenuDirection: state.params.subMenuDirection,
  currentOrganization: state.auth.currentOrganization
});

export default connect(mapStateToProps)(CollaboratorTimeSheetPage);



// WEBPACK FOOTER //
// ./src/components/TimeSheet/CollaboratorTimeSheetPage.js